var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColoredFileStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-storage 1",
    clipPath: "url(#clip0_8748_6562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6031 7.93956H10.3412C9.96589 7.93951 9.60736 7.78421 9.35069 7.51046L7.89922 5.96299C7.64211 5.68899 7.28303 5.53373 6.90726 5.53418H2.17938C1.42934 5.53418 0.821289 6.14223 0.821289 6.89228V22.0386C0.821289 22.7895 1.42999 23.3982 2.18087 23.3982H21.6005C22.3514 23.3982 22.9601 22.7895 22.9601 22.0386V9.29771C22.9601 8.54806 22.3527 7.94021 21.6031 7.93956Z",
    fill: "#50B1BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.07227 0.601562H20.5773V15.3797H4.07227V0.601562Z",
    fill: "#4C549D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.20605 1.97363H19.2085V16.2495H3.20605V1.97363Z",
    fill: "#6E79DE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.01562 3.78906H17.3998V4.43883H5.01562V3.78906Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.01562 5.85352H17.3998V6.50329H5.01562V5.85352Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.01562 7.91699H17.3998V8.56676H5.01562V7.91699Z",
    fill: "white",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.6426 10.1191H10.3401C9.96576 10.1191 9.60803 10.2736 9.35136 10.5462L7.8993 12.0878C7.64268 12.3603 7.28494 12.5148 6.91056 12.5148H1.35814C0.6081 12.5148 4.96652e-05 13.1228 0 13.8729C0 13.9142 0.00188728 13.9554 0.00561216 13.9965L0.708076 22.1626C0.771946 22.8627 1.35904 23.3987 2.0621 23.3987H21.7194C22.4225 23.3987 23.0097 22.8626 23.0734 22.1623L23.9942 11.601C24.0626 10.8541 23.5125 10.1932 22.7656 10.1248C22.7247 10.1211 22.6837 10.1192 22.6426 10.1191Z",
    fill: "#C1DBFC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8748_6562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredFileStorage);
export default __webpack_public_path__ + "static/media/colored-file-storage.2f755efcbd8bad6b377e03f8e53b4069.svg";
export { ForwardRef as ReactComponent };